$(() => {
  //
  $("img[data-src]")
    .not(".lazy")
    .each(function () {
      const $img = $(this);
      const src = $img.attr("data-src");
      $img.attr("src", src);
    });
  //
  $("[data-bg]")
    .not(".lazy")
    .each(function () {
      const $t = $(this);
      const bgSrc = $t.attr("data-bg");
      $t.css({
        backgroundImage: `url("${bgSrc}")`,
      });
    });
  //--------------------------------------------------------
  const handleScroll = _.throttle(
    function () {
      const windowHeight = $(window).height();
      const scrollTop = $(window).scrollTop();
      $(".lazy").each(function () {
        const $t = $(this);
        const height = $t.height();
        const offsetTop = $t.offset().top; //和整个页面顶部之间的距离
        const fixTop = offsetTop - scrollTop; //和窗口顶部之间的距离
        const fixBottom = scrollTop + windowHeight - offsetTop - height; //和窗口底部之间的距离

        if (fixTop < windowHeight && fixBottom < windowHeight) {
          const src = $t.attr("data-src");
          const bgSrc = $t.attr("data-bg");
          // const poster = $t.attr("poster");
          src && $t.attr("src", src);
          // poster && $t.attr("poster", poster);
          bgSrc &&
            $t.css({
              backgroundImage: `url("${bgSrc}")`,
            });
          $t.removeClass("lazy");
        }
      });
    },
    300,
    { trailing: true }
  );
  //
  $(window).on("scroll", handleScroll);
  $("html,body").on("scroll", handleScroll);
  handleScroll();
});
